import Cookies from 'universal-cookie';

import { isInWebView } from '@/components/Client/shared/webview/env';

import { decrypt, encrypt } from './encrypt';
import { handleError } from './handleError';
import { safeLocalStorage } from './helpers/DOM';

const cookies = new Cookies(null, { path: '/' });

const LS_USER_KEY = 'hash';
const LS_CLIENT_KEY = 'client-hash';

// Allur user token management

interface IAllurTokenData {
  accessToken: string;
  refreshToken: string;
  emailAllur: string;
}

const USER_TOKEN_EMPTY: IAllurTokenData = {
  accessToken: '',
  refreshToken: '',
  emailAllur: ''
};

let userTokenMemory: IAllurTokenData | null = null;

export const setUserToken = (data: IAllurTokenData): void => {
  const encrypted = encrypt(JSON.stringify(data));
  cookies.set(LS_USER_KEY, encrypted);
  // Если токен не установлен в cookies, устанавливаем в localStorage
  if (!cookies.get(LS_USER_KEY)) safeLocalStorage.set(LS_USER_KEY, encrypted);
  userTokenMemory = data;
};

export const getUserToken = (): IAllurTokenData => {
  try {
    const fromCookie = cookies.get(LS_USER_KEY);
    if (fromCookie) return JSON.parse(decrypt(fromCookie));

    const fromLS = safeLocalStorage.get(LS_USER_KEY);
    if (fromLS) return JSON.parse(decrypt(fromLS));

    return userTokenMemory ?? USER_TOKEN_EMPTY;
  } catch (error) {
    handleError(error, {
      notify: false
    });
    return userTokenMemory ?? USER_TOKEN_EMPTY;
  }
};

export const removeUserToken = (): void => {
  cookies.remove(LS_USER_KEY);
  safeLocalStorage.remove(LS_USER_KEY);
  userTokenMemory = null;
};

// -------------------------------

// Client module user token management

interface IClientTokenData {
  accessToken: string;
  iin: string;
}

let clientTokenMemory: IClientTokenData | null = null;

export const setClientToken = (data: IClientTokenData): void => {
  // В WebView токен приходит через sso/auth и хранится в другом месте (ssoJwtToken)
  if (isInWebView()) return;
  const encrypted = encrypt(JSON.stringify(data));
  cookies.set(LS_CLIENT_KEY, encrypted);
  // Если токен не установлен в cookies, устанавливаем в localStorage
  if (!cookies.get(LS_CLIENT_KEY))
    safeLocalStorage.set(LS_CLIENT_KEY, encrypted);
  clientTokenMemory = data;
};

export const getClientToken = (): IClientTokenData | null => {
  try {
    const fromCookie = cookies.get(LS_CLIENT_KEY);
    if (fromCookie) return JSON.parse(decrypt(fromCookie));

    const fromLS = safeLocalStorage.get(LS_CLIENT_KEY);
    if (fromLS) return JSON.parse(decrypt(fromLS));

    return clientTokenMemory;
  } catch (error) {
    handleError(error, {
      notify: false
    });
    return null;
  }
};

export const removeClientToken = (): void => {
  cookies.remove(LS_CLIENT_KEY);
  safeLocalStorage.remove(LS_CLIENT_KEY);
  clientTokenMemory = null;
};

// -------------------------------
